import { HttpContextToken } from '@angular/common/http';

export const DISABLE_HTTP_ERROR_NORMALIZATION: HttpContextToken<boolean> = new HttpContextToken<boolean>(() => false);
